export default{
    Submit:"представлять на рассмотрение",
    Submitting:'представление',
    Uploading:"загрузка",
    Logging_in:"Вход в систему",
    Loading:"загрузка",
    Pull_down:"Потяните вниз, чтобы обновить...",
    Release_refresh:"Отпустите, чтобы обновить...",
    Please_login:"Пожалуйста войдите",
    System_busy:"Система занята",
    Login_succeeded:"Авторизация успешна",
    Recharging:"Подзарядка",
    Purchasing:"Покупка",
    Receiving:"Получение",
    Activating:"Активация",
    Extracting:"Извлечение",
    Buying:"Покупка",
    Buy:"Купить",
    Opening:"Включаю.",


    login:"Авторизоваться",
    first_login:"При первом входе в систему вам необходимо будет установить пароль, пожалуйста, запомните его!",

    Not_connected:'Кошелек не подключен',
    connect_wallet:"Подключить кошелек",
    please_connect_wallet:"Пожалуйста, подключите кошелек",
    Network_error:"Ошибка сетевого подключения",
    wait_confirm:"Пожалуйста, дождитесь подтверждения в сети.",

    enter_login_psw:"Пожалуйста введите ваш пароль",
    modified_success:'Успешно изменено',
    twopsw_not_match:"Новый пароль, введенный дважды, неверен",
    Change_password:"изменить пароль",
    Disconnect:"Отключить",
    enter_old_password:"Пожалуйста, введите оригинальный пароль",
    enter_new_password:"Пожалуйста, введите новый пароль",
    enter_Confirm_Password:"Пожалуйста, введите новый пароль еще раз",
    Confirm:'подтверждать',
    Cancel:"Отмена",

    home:"титульная страница",

    Recharge:"Валюта",
    Withdraw:'нести',
    Exchange:"Обмен",
    transfer:"передача",
    Transfer_records:"Запись о передаче",
    Transfer_in:"перевод в",
    Transfer_out:"Трансфер в",
    wallet:"кошелек",
    Draw_cards:"Выбрать",
    Work_card:"Профессия",
    Chance_card:"шанс карты",
    Explain:"иллюстрировать",


    Currency:'Вывод монет',
    Enter_withdraw_num:'Введите сумму вывода',
    handling_fee:"Плата за обработку:",
    amount:'количество:',
    quantity_not_range:"Сумма выведенных монет не находится в пределах диапазона",

    Enter_recharge_quantity:"Количество",
    recharge_not_range:"Количество денег в пределах",
    recharge_base:"Валютная база является",

    Wallet_address:"адрес кошелька",
    enter_Wallet_address:"Пожалуйста, введите адрес кошелька",
    transfer_num:"количество",
    Please_enter_num:"Пожалуйста, введите количество",
    transfer_balance:"Баланс:",
    
    Copied_successfully:"Скопировано успешно",
    copy_failed:"Не удалось скопировать",
    authorize_first:"Пожалуйста, сначала авторизируйтесь",

    Working:"Работа",
    trade_for:"запись о передаче",
    Unemployed:"Безработные",
    In_office:"На работе",
    Financial_value:"ценить:",
    job_hunt:"Работа",
    cede:"передача",
    Congratulations_receiving:"Поздравляем с получением",
    sure_job:"Вы уверены, что претендуете на работу?",
    sure_transfer:"Подтвердить перевод?",
    Successful_job:"Успешное занятие.",
    enter_transfer_address:"Пожалуйста, введите адрес перевода",
    Transfer_successful:"Перенос успешен",

    Bank:"банк",
    enter_extraction:"Количество",
    enter_deposit:"Количество",
    Extraction_successful:"Извлечение успешно",
    Deposit_successful:"Депозит успешен",
    Deposit:"Депозит",
    Extract:"извлекать",

    Internship:"Стажеры",
    not_active:"Для активации",
    Activated:"активирован",
    give:"отдавать",
    invalid:"Неверный",
    activate:"активация",
    Value:'ценить:',
    Transfer_to:"Выезд в:",
    day:"небо",
    enter_give:"Введите адрес перевода",
    sure_Activate_earning:"Активация начинает приносить преимущества. Вы уверены, что активируете?",
    Activation_successful:"Активация прошла успешно",

    Received_successfully:"Получено успешно",
    choose_payment:"Пожалуйста, выберите способ оплаты",
    Payment_method:"способ оплаты",
    Entrepreneurship:"Начать бизнес",
    Ended:"над",
    y_invalid:"истекший",
    Amount:"количество",
    lifespan:"Срок годности:",
    cycle:"цикл",
    From_end:"С конца:",
    Total_value:"Вход:",
    Total_revenue:"доход:",
    Receive:"получать",
    Price:"цена:",
    Yield_ratio:'доход:',
    Cycle1:"цикл:",
    Activation_time:'Время активации:',
    End_time:'Время окончания:',
    End_of_earnings:'Конечный доход:',

    Master_disciple:"Гильдия",
    Today_earnings:"Сегодняшний доход",
    TotalSY_performance:"Совокупный доход",
    Team_performance:"Уровень коллегии",
    Team_TeamPer:"Вклад",
    binding:"обязательность",
    details:"Подробности",
    My_Referrals:"Моя рекомендация.",

    
    one_level:"Уровень 1",
    two_level:"Уровень 2",
    Copy:"копировать",
    Invitation_link:"приглашать Связь:",
    enter_master:"Пожалуйста, введите адрес рекомендателя.",
    Binding_successful:"Привязка прошла успешно",
    detailed:"детальный",

    Blind_box:"глухая коробка",
    occupation:'Профессия:',
    see:"Проверять",
    open:"включать",
    Open_box:"Открытая глухая коробка",
    sure_Open_box:"Вы уверены, что включите слепой ящик?",
    Congratulations_obtaining:"Поздравления",
    Introduction:'представлять:',
    Recharge_Record:"Монетные записи",
    Recharge1:'Валюта:',
    
    Exchange_record:"Запись обмена",
    Enter_exchange:"Количество",
    Exchange_rate:"обменный курс",
    exchange_range:"Сумма погашения находится за пределами диапазона",

    Chance_card_draw:"брать карты",
    My_opportunity:"моя карта шанса",
    Draw:'Kурить',
    Draw_cards1:"Извлечь сейчас",
    Card_Description:"Описание карты:",
    profit:"доход:",
    drawing_expenses:"Потребление карточек.",
    Confirm_extraction:",Подтвердить откачку?",

    Enter_buy_quantity:"Введите количество покупок",
    buy_not_range:"Количество покупок не входит",
    Withdraw_record:"Запись",
    Withdrawal:"Вывод монет:",
    Reason_refusal:'Причины отказа:',
    Enter_transfer_Count:"Количество",
    Transfer_address:"Адрес перевода",
    transfer_range:"Количество переводов не покрывается",

    Withdraw1:"Вывод монет",
    Enter_withdrawal_quantity:"Количество",
    Service_Charge:'Плата за оформление:',
    withdrawal_range:"Извлеченные суммы не покрываются",
    reference:'Рекомендуемые:',
    Extract_work_card:"Рабочая карточка",
    One_click_claim:"Получать",
    Expiration_time:"Срок действия:",
    Transfer_time:"Время передачи:",

    buy_time:"Время покупки:",
    To_be_purchased:"Будут закуплены",
    Purchased:"Приобретено", 
    Yield_rate:"Норма прибыли:",
    Total_amount:'Общий объем:',
    Unit_Price:"Цены:",
    Remaining_time:"Эффективное время:",
    invest_cycle:"цикл:",
    Daily_decreasing:"День Уменьшение:",
    Financial_IQ:"Финансы:",

}